// extracted by mini-css-extract-plugin
export default {"header":"ab8kM1","headerContainer":"Bjomd2","headerTitle":"dBXqYA","subTitle":"luaEHm"};